module.exports = __webpack_public_path__ + "img/路径 7(描边).db2ecc30.png";